import React from "react";
import { Trash2, Save } from "lucide-react";

const NUMERIC_FIELDS = [
  ["pairs", 12],
  ["price", 20],
  ["saving", 20],
];

const BundleRow = ({ b, idx, saving, onFieldChange, onSave, onDelete }) => (
  <tr className="border-b border-line" data-testid={`bundle-row-${b.slug}`}>
    <td className="px-3 py-2">
      <input
        value={b.name}
        onChange={(e) => onFieldChange(idx, "name", e.target.value)}
        className="w-full border border-transparent hover:border-line focus:border-ink bg-transparent px-1.5 py-1"
      />
      <p className="mono text-[10px] text-mute mt-0.5">{b.slug}</p>
    </td>
    {NUMERIC_FIELDS.map(([key, w]) => (
      <td key={key} className="px-3 py-2">
        <input
          type="number"
          step={key === "pairs" ? "1" : "0.01"}
          value={b[key] ?? 0}
          onChange={(e) => onFieldChange(idx, key, e.target.value)}
          className={`w-${w} border border-line bg-chalk px-1.5 py-1 mono`}
        />
      </td>
    ))}
    <td className="px-3 py-2">
      <input
        value={b.tag || ""}
        onChange={(e) => onFieldChange(idx, "tag", e.target.value)}
        className="w-40 border border-line bg-chalk px-1.5 py-1"
      />
    </td>
    <td className="px-3 py-2 text-center">
      <input
        type="checkbox"
        checked={Boolean(b.featured)}
        onChange={(e) => onFieldChange(idx, "featured", e.target.checked)}
      />
    </td>
    <td className="px-3 py-2 text-center">
      <input
        type="checkbox"
        checked={Boolean(b.is_active)}
        onChange={(e) => onFieldChange(idx, "is_active", e.target.checked)}
      />
    </td>
    <td className="px-3 py-2 text-right whitespace-nowrap">
      {b._dirty && (
        <button
          type="button"
          onClick={() => onSave(b)}
          disabled={saving}
          className="text-[10px] tracking-widest uppercase font-bold px-2 py-1 bg-ink text-white mr-2"
          data-testid={`bundle-save-${b.slug}`}
        >
          <Save size={11} className="inline mr-1" />
          {saving ? "…" : "Save"}
        </button>
      )}
      <button
        type="button"
        onClick={() => onDelete(b)}
        className="text-mute hover:text-ink p-1"
      >
        <Trash2 size={12} />
      </button>
    </td>
  </tr>
);

export default BundleRow;
